import React, { useState } from "react";
import { Container, Image, Form} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
// import {
//   ViewOffSlashIcon,
//   EyeIcon,
//   CheckmarkBadge04Icon,
//   BackArrowIcon,
// } from "../../assets/icons";
// import logoBlack from "../../assets/images/logo/logo-dark.png";
import LoginLogo from "../../assets/images/login/shapes/login-logo.png";
import "./Styles/Otp.css";
// import { useDispatch, useSelector } from "react-redux";
import CommonButton from "../../components/commonButton";
// import CommonFormLabel from "../../components/formLabel";
// import Input from "../../components/input";
import { routes } from "../../routes/PageRoutes";
import OtpInput from "react-otp-input";

const VerifyOtp = () => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  // const [showToast, setShowToast] = useState(false);
  // const [showEyeIcon, setShowEyeIcon] = useState(false);
  // const [toastMessage, setToastMessage] = useState("");
  // const [toastVariant, setToastVariant] = useState("toast-success");
  const [otp, setOtp] = useState("");
  const [isValid, setIsValid] = useState(null); // null = neutral, true = valid, false = invalid

  // const { status, error } = useSelector((state) => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate(routes.home);
  };

  return (
    <>
      <Container fluid="xxl" className="mx-auto px-4">
        <div className="d-flex align-items-center justify-content-center py-4  login-content">
          <div className="position-relative w-100 py-4 login-sub-content">
            <div className="bg-white rounded-2 p-5 common-shadow login-card">
              <h1 className="fs-5 d-flex align-content-center justify-content-center mb-4">
                <Link
                  to="https://mep.in/"
                  className=" text-decoration-none  d-inline-block"
                >
                  <Image src={LoginLogo} alt="Site-Logo" />
                </Link>
              </h1>
              <div className="mb-4 welcome-content">
                <h4 className="mb-1 fw-medium text-start">OTP Verification</h4>
                <p className="text-start">
                  We sent a verification code to your mobile.
                </p>
              </div>

              <Form onSubmit={handleSubmit}>
                <div className="mb-5">
                  <OtpInput
                    value={otp}
                    onChange={(value) => {
                      setOtp(value);
                      setIsValid(null); // Reset validation state while typing
                    }}
                    numInputs={4}
                    renderSeparator={<span className="otp-separator"></span>}
                    renderInput={(props) => (
                      <input
                        {...props}
                        className={`otp-input 
                          ${isValid === null ? "" : isValid ? "valid" : "invalid"}`
                        }
                      />
                    )}
                    containerStyle="otp-container"
                    shouldAutoFocus
                  />
                </div>

                {/* <div className="mb-3 welcome-content align-items-center justify-content-center gap-2 mt-2">
                  <p className="text-center">Didn't recieve OTP code?</p>
                  <div className="text-center resend-code-link">
                    Resend Code
                  </div>
                </div> */}

                <CommonButton
                  title="Verify"
                  type="submit"
                  className="w-100 btn-primary primary-shadow"
                  disabled={isValid}
                />

                <div className="mb-4 welcome-content d-flex align-items-center justify-content-center gap-2 mt-4">
                  <p className="para">Didn't receive OTP?</p>
                  <div className="register-link">
                    <Link
                      to={routes.register}
                      className="text-decoration-none "
                    >
                      Resend
                    </Link>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default VerifyOtp;
